import GlobalStyleComponent from "/home/runner/work/alliance-venture/alliance-venture/web/src/styles/global";
export default GlobalStyleComponent;
